import React from "react";
import {Button, Grid, TextField} from "@mui/material";
import {useSeguranca} from "@contexts/SegurancaContext.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {IRoleNovaDto} from "@models/roles/rolesDto.ts";
import {DefaultEventProps} from "@models/DefaultProps.ts";
import {IRole} from "@models/roles/roles.ts";

interface CreateRoleProps extends Pick<DefaultEventProps<IRole>, 'onCreate'> {
}


export function CreateRoleComponent(props: CreateRoleProps) {
    const {onCreate} = props;

    const [dados, setDados] = React.useState<IRoleNovaDto>({
        nome: '',
        descricao: ''
    })

    const {createRole} = useSeguranca()
    const {createAlertFromResponse} = useAlert()

    const createContaHandler = async () => {
        await createRole(dados).then(res => {
            createAlertFromResponse(res)
            if (res.status === 'Success') {
                if (onCreate != null)
                    onCreate(res.items)
            }

        })
    }

    return (
        <Grid container>
            <Grid size={12}>
                <TextField required placeholder={'Nome da role'} value={dados.nome} error={dados.nome.length < 4}
                           onChange={(e) => {
                               setDados({...dados, nome: e.target.value})
                           }}/>
            </Grid>
            <Grid size={12}>
                <TextField required placeholder={'Descrição'} value={dados.descricao || ''}
                           onChange={(e) => {
                               setDados({...dados, descricao: e.target.value})
                           }}/>
            </Grid>
            <Grid size={12}>
                <Button onClick={createContaHandler}
                        fullWidth>
                    Criar
                </Button>
            </Grid>
        </Grid>
    )
}